import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

import { getToken, removeToken } from '../utils/auth'
import { validateToken } from '../utils/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'login' },
  },
  {
    path: '/judge',
    name: 'judge',
    component: () => import('../pages/judge/JudgePage.vue'),
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'meetings-list' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'meetings',
        path: 'meetings',
        component: RouteViewComponent,
        redirect: { name: 'meetings-list' },
        children: [
          {
            name: 'meetings-list',
            path: 'list',
            component: () => import('../pages/meetings/MeetingsList.vue'),
          },
          // 添加模板列表路由
          {
            name: 'templates-list',
            path: 'templates',
            component: () => import('../pages/meetings/TemplatesList.vue'),
          },
        ],
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

// 添加路由守卫
router.beforeEach(async (to, from, next) => {
  const token = getToken()

  // 白名单路由，不需要验证token
  const whiteList = ['/auth/login', '/judge']

  if (token) {
    if (to.path === '/auth/login') {
      // 已登录且要跳转登录页，重定向到首页
      next({ path: '/' })
    } else {
      // 验证 token 的真实性
      const isValidToken = await validateToken()

      if (isValidToken) {
        next()
      } else {
        // token 无效，清除 token 并跳转到登录页
        removeToken()
        next(`/auth/login?redirect=${to.path}`)
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      // 未登录可以访问白名单页面
      next()
    } else {
      // 未登录则跳转到登录页面
      next(`/auth/login?redirect=${to.path}`)
    }
  }
})

export default router
